import Projects from "./Projects";
import Contact from "./Contact";
import AboutMe from "./AboutMe";
// import { ReactTyped } from "react-typed";
import { useRef, useEffect } from "react";

export default function Home() {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.5;
    }
  }, []);

  return (
    <div className="text-center">
      {/* Hello Section */}
      <section id="Home" className="w-full">
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsinline
          preload="auto"
          className="bg-video opacity-25"
        >
          <source src="/vidbg1.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-container">
          <div className="flex flex-col h-fit my-auto gap-5">
            <div>
              <div className="hello">
                Hey, it's&nbsp; <span class="text-fuchsia-500"> Renee</span>!
              </div>
              <p className="text-indigo-300 text-center">
                I am a UI UX designer and a Web Developer.
              </p>

              {/* <p className="text-white text-left">
                I am&nbsp;
                <ReactTyped
                  strings={[
                    "a UI UX Designer",
                    "a Frontend Developer",
                    "an OOP enthusiast",
                    "an aspiring Cloud Engineer",
                  ]}
                  typeSpeed={100}
                  backSpeed={50}
                  showCursor
                  smartBackspace
                  loop
                  contentType="html" // This tells it to render the string as HTML
                  className="text-white"
                />
              </p> */}
            </div>

            <a href="/KHAN, Renee Althea - Resume.pdf" target="_blank">
              <button className="badge-style text-lg w-full hover:bg-white/25">
                Resume{" "}
              </button>{" "}
            </a>

            <a
              href="https://github.com/renee-kh4n"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="darker-badge-style hover:bg-fuchsia-400/25 text-lg w-full">
                Github{" "}
              </button>{" "}
            </a>
          </div>
          <img
            src="/KhanRenee_pfp.png"
            alt="profile_picture"
            className="profile-pic"
          />
        </div>
      </section>

      <AboutMe />
      <Projects />
      <Contact/>
    </div>
  );
}
